import React from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

const Header = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);

  React.useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="header">
      <h3 className="header__title" onClick={() => setIsOpen(false)}><Link to='/' className='header__title'>Cristina Gromov</Link></h3>
      <nav className={`header__nav ${isOpen ? 'header__nav--open' : ''}`}>
        <ul>
        {isOpen && screenWidth < 853 && <li>
            <Link to='/' className="header__nav-link" onClick={toggleMenu}>
              Home
            </Link>
          </li>}
          <li>
            <Link to='/about' className="header__nav-link" onClick={toggleMenu}>
              About
            </Link>
          </li>
          <li>
            <Link to='/#cases' className="header__nav-link" onClick={toggleMenu}>
              Cases
            </Link>
          </li>
          {/* <li>
            <Link to='/playground' className="header__nav-link" onClick={toggleMenu}>
              Playground
            </Link>
          </li> */}
          <li>
            <a href='https://www.linkedin.com/in/krsgromov/' target="_blank" rel="noreferrer" className="header__nav-link link-linkedIn" onClick={toggleMenu}>
              LinkedIn
            </a>
          </li>
          <li>
            <a href='#footer' className="header__nav-link" onClick={toggleMenu}>
              Contact me
            </a>
          </li>
        </ul>
      </nav>
      <div className="header__burger" onClick={toggleMenu}>
        <span className="header__burger-line"></span>
        {!isOpen && <span className="header__burger-line"></span>}
      </div>
    </div>
  );
};

export default Header;
